var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdirLogoGrnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8682 0.399994L29.1615 10.0896L19.4341 0.399994H0V58.6H19.4341V52.1333H38.8682V58.6H58.3231V0.399994H38.8682Z",
    fill: "#005E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdirLogoGrnn);
export default __webpack_public_path__ + "static/media/Mdir_Logo_Grønn.2fd9669d9769bfb455ab7c2d4c94fc04.svg";
export { ForwardRef as ReactComponent };